<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
  {{ "bikeshop.shop_setup.card_headers.rental_configuration" | translate }}
</span>
    </div>
  </div>
  <div>
    <div *ngIf="RentalConfigForm">
      <div class="row">
        <div class="col-md-12">
          <div class="content">
            <form [formGroup]="RentalConfigForm" (ngSubmit)="saveConfig(RentalConfigForm.value)">

              <div class="row">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.configuration.message_settings' | translate }}
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['reservationTimeValue_BeforeStartReminder'].invalid}">
                  {{ "bikeshop.rentals.configuration.message_reservation_reminder_1" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <!-- Dropdown for Hours/Minutes -->
                    <p-dropdown 
                      [options]="timeUnits" 
                      formControlName="reservationTimeUnit_BeforeStartReminder" 
                      placeholder="Select Unit" 
                      class="timeunit-dropdown">
                    </p-dropdown>

                    <!-- Input for number -->
                    <input type="number" 
                          pInputText 
                          formControlName="reservationTimeValue_BeforeStartReminder" 
                          min="0"/>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.message_reservation_reminder_description_1' |
                    translate }}</small></div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['reservationTimeValue_BeforeReturnReminder'].invalid}">
                  {{ "bikeshop.rentals.configuration.message_return_reminder_1" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <!-- Dropdown for Hours/Minutes -->
                    <p-dropdown 
                      [options]="timeUnits" 
                      formControlName="reservationTimeUnit_BeforeReturnReminder" 
                      placeholder="Select Unit" 
                      class="timeunit-dropdown">
                    </p-dropdown>

                    <!-- Input for number -->
                    <input type="number" 
                          pInputText 
                          formControlName="reservationTimeValue_BeforeReturnReminder" 
                          min="0"/>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.message_return_reminder_description_1' |
                    translate }}</small></div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['reservationTimeValue_AfterReturnOverdueReminder'].invalid}">
                  {{ "bikeshop.rentals.configuration.message_return_overdue_1" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                     <!-- Dropdown for Hours/Minutes -->
                    <p-dropdown 
                      [options]="timeUnits" 
                      formControlName="reservationTimeUnit_AfterReturnOverdueReminder" 
                      placeholder="Select Unit" 
                      class="timeunit-dropdown">
                    </p-dropdown>

                    <!-- Input for number -->
                    <input type="number" 
                          pInputText 
                          formControlName="reservationTimeValue_AfterReturnOverdueReminder" 
                          min="0"/>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.message_return_overdue_description_1' |
                    translate }}</small></div>
              </div>

              <div class="row">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.configuration.rental_rules' | translate }}
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['maxRentalsPerDay'].invalid}">
                  {{ "bikeshop.rentals.configuration.max_rentals_per_day" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="maxRentalsPerDay"/>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.max_rentals_per_day_description' |
                    translate }}</small></div>
              </div>
              <!-- <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': RentalConfigForm.controls['maxProductsOutAnyGivenTime'].invalid}">
                  {{ "bikeshop.rentals.configuration.max_products_out_any_given_time" | translate }}:
                </div>
                <div class="col-md-2">
                  <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="maxProductsOutAnyGivenTime" />
                  </div>
                </div>
                <div class="col-md-6 label"><small>{{ 'bikeshop.rentals.configuration.max_products_out_any_given_time_description' | translate }}</small></div>
              </div> -->
              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['maxRentalsSameSlot'].invalid}">
                  {{ "bikeshop.rentals.configuration.max_rentals_same_slot" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="maxRentalsSameSlot"/>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.max_rentals_same_slot_description'
                    | translate }}</small></div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['staggerMinutesInterval'].invalid}">
                  {{ "bikeshop.rentals.configuration.stagger_interval" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-clock-o"></i></span>
                    <input type="number" pInputText formControlName="staggerMinutesInterval"/>
                    <div class="label">{{ 'general.minutes' | translate }}</div>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.stagger_interval_desc' | translate }}</small>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['bufferMinutesBetweenRentals'].invalid}">
                  {{ "bikeshop.rentals.configuration.buffer_time_between_rentals" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-clock-o"></i></span>
                    <input type="number" pInputText formControlName="bufferMinutesBetweenRentals"/>
                    <div class="label">{{ 'general.minutes' | translate }}</div>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.buffer_time_between_rentals_desc' | translate }}</small>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['availabilityBufferDays'].invalid}">
                  {{ "bikeshop.rentals.configuration.availability_buffer_time" | translate }}:
                </div>
                <div class="col-md-3 label">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-calendar-o"></i></span>
                    <input type="number" pInputText formControlName="availabilityBufferDays"/>
                    <div class="label">{{ 'bikeshop.rentals.booking.days' | translate }}</div>
                  </div>
                </div>
                <div class="col-md-6 label">
                  <small>{{ 'bikeshop.rentals.configuration.availability_buffer_time_desc' |
                    translate }}</small></div>
              </div>


              <div>
                <div class="row margin-top-16">
                  <div class="col-md-12 section-header"
                       [ngClass]="{'red': !RentalConfigForm.value.allowFixedRentalOptions && !RentalConfigForm.value.allowFlexibleRentalOptions}">
                    {{ 'bikeshop.rentals.configuration.reservation_durations' | translate }}
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.allowFixedRentalOptions && !RentalConfigForm.value.allowFlexibleRentalOptions}">
                    {{ "bikeshop.rentals.configuration.allow_fixed_rental_options" | translate }}:
                  </div>
                  <div class="col-md-1">
                    <p-inputSwitch formControlName="allowFixedRentalOptions"></p-inputSwitch>
                  </div>
                  <div class="col-md-8 label">
                    <small>{{ 'bikeshop.rentals.configuration.allow_fixed_rental_options_info' | translate }}</small>
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.allowFixedRentalOptions && !RentalConfigForm.value.allowFlexibleRentalOptions}">
                    {{ "bikeshop.rentals.configuration.allow_flexible_rental_options" | translate }}
                    :
                  </div>
                  <div class="col-md-1">
                    <p-inputSwitch formControlName="allowFlexibleRentalOptions"></p-inputSwitch>
                  </div>
                  <div class="col-md-8 label">
                    <small>{{ 'bikeshop.rentals.configuration.allow_flexible_rental_options_info' | translate }}</small>
                  </div>
                </div>
              </div>


              <div *ngIf="(isStipeIntegrated || isPaystackIntegrated || isSquareIntegrated) && isPOSPaymentsSupported">
                <div class="row margin-top-16">
                  <div class="col-md-12 section-header">
                    {{ 'bikeshop.rentals.configuration.payment' | translate }}
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.take_payment_during_online_booking" | translate }}
                    :
                  </div>
                  <div class="col-md-9">
                    <p-inputSwitch formControlName="paymentOnCheckout"></p-inputSwitch>
                  </div>
                </div>
                <div class="row margin-top-8" *ngIf="RentalConfigForm.value.paymentOnCheckout">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.fullPaymentOrDeposit}">
                    {{ "bikeshop.rentals.configuration.payment_full_or_deposit" | translate }}:
                  </div>
                  <div class="col-md-9 radio-container">
                    <p-radioButton name="fullPaymentOrDeposit" value="FULL"
                                   formControlName="fullPaymentOrDeposit"
                                   label="{{ 'bikeshop.rentals.configuration.full_payment' | translate }}"
                                   [disabled]="!RentalConfigForm.value.paymentOnCheckout"></p-radioButton>
                    <p-radioButton name="fullPaymentOrDeposit" value="DEPOSIT" *ngIf="partner.POSSystemID !== 17"
                                   formControlName="fullPaymentOrDeposit"
                                   label="{{ 'bikeshop.rentals.configuration.deposit' | translate }}"
                                   [disabled]="!RentalConfigForm.value.paymentOnCheckout"></p-radioButton>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="RentalConfigForm.value.paymentOnCheckout && RentalConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.depositPercentOrFixed}">
                    {{ "bikeshop.rentals.configuration.deposit_percent_or_fixed" | translate }}:
                  </div>
                  <div class="col-md-9 radio-container">
                    <p-radioButton name="depositPercentOrFixed" value="PERCENT"
                                   formControlName="depositPercentOrFixed"
                                   label="{{ 'bikeshop.rentals.configuration.percent' | translate }}"></p-radioButton>
                    <p-radioButton name="depositPercentOrFixed" value="FIXED"
                                   formControlName="depositPercentOrFixed"
                                   label="{{ 'bikeshop.rentals.configuration.fixed' | translate }}"></p-radioButton>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="RentalConfigForm.value.paymentOnCheckout && RentalConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT' && RentalConfigForm.value.depositPercentOrFixed === 'PERCENT'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.depositValue}">
                    {{ "bikeshop.rentals.configuration.deposit_percent_amount" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>%</i></span>
                      <input type="number" pInputText formControlName="depositValue" />
                    </div>
                  </div>
                </div>
                <div class="row margin-top-8" 
                     *ngIf="RentalConfigForm.value.paymentOnCheckout && RentalConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT' && RentalConfigForm.value.depositPercentOrFixed === 'FIXED'">
                  <div class="col-md-3 label" 
                       [ngClass]="{'red': !RentalConfigForm.value.depositValue}">
                    {{ "bikeshop.rentals.configuration.deposit_fixed_amount" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                      <input type="number" pInputText formControlName="depositValue"  />
                    </div>
                  </div>
                </div>

              </div>

              <div *ngIf="isStipeIntegrated && isPOSPaymentsSupported && RentalConfigForm.value.paymentOnCheckout">
                <div class="row margin-top-16">
                  <div class="col-md-12 section-header">
                    {{ 'bikeshop.rentals.configuration.security_deposits' | translate }}
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.take_security_deposit" | translate }}:
                  </div>
                  <div class="col-md-2">
                    <p-inputSwitch formControlName="deductSecurityDeposit"></p-inputSwitch>
                  </div>
                  <div class="col-md-7 label">
                    <small>{{ 'bikeshop.rentals.configuration.take_security_deposit_info' | translate }}</small>
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.security_deposit_hours_before_rental" | translate }}
                    :
                  </div>
                  <div class="col-md-2">
                    <input type="number" pInputText
                           formControlName="hoursBeforeReservationToDeductSecurityDeposit"/>
                  </div>
                  <div class="col-md-7 label">
                    <small>{{ 'bikeshop.rentals.configuration.security_deposit_hours_before_rental_info' | translate
                      }}</small>
                  </div>
                </div>
              </div>


              <div>
                <div class="row margin-top-16">
                  <div class="col-md-12 section-header">
                    {{ 'bikeshop.rentals.configuration.booking_fee' | translate }}
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.add_booking_fee" | translate }}:
                  </div>
                  <div class="col-md-2">
                    <p-inputSwitch formControlName="addBookingFee" (onChange)="handleAddBookingFeee($event)"></p-inputSwitch>
                  </div>
                  <div class="col-md-7 label">
                    <small>{{ 'bikeshop.rentals.configuration.add_booking_fee_desc' | translate }}</small>
                  </div>
                </div>
                <div class="row margin-top-8" *ngIf="RentalConfigForm.value.addBookingFee">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.bookingFeePercentOrFixed}">
                    {{ "bikeshop.rentals.configuration.booking_fee_type" | translate }}:
                  </div>
                  <div class="col-md-9 radio-container" [ngClass]="{'disabled' : !canEdit}">
                    <p-radioButton name="bookingFeePercentOrFixed" value="PERCENT" 
                                   formControlName="bookingFeePercentOrFixed" [disabled]="!canEdit" [ngClass]="{'disabled' : !canEdit}"
                                   label="{{ 'bikeshop.rentals.configuration.percent' | translate }}"></p-radioButton>
                    <p-radioButton name="bookingFeePercentOrFixed" value="FIXED"
                                   formControlName="bookingFeePercentOrFixed" [disabled]="!canEdit" [ngClass]="{'disabled' : !canEdit}"
                                   label="{{ 'bikeshop.rentals.configuration.fixed_amount' | translate }}"></p-radioButton>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="RentalConfigForm.value.addBookingFee && RentalConfigForm.value.bookingFeePercentOrFixed === 'PERCENT'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.bookingFeeValue}">
                    {{ "bikeshop.rentals.configuration.deposit_percent_amount" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>%</i></span>
                      <input type="number" pInputText formControlName="bookingFeeValue" />
                    </div>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="RentalConfigForm.value.addBookingFee && RentalConfigForm.value.bookingFeePercentOrFixed === 'FIXED'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.bookingFeeValue}">
                    {{ "bikeshop.rentals.configuration.add_booking_fee_fixed_value" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                      <input type="number" pInputText formControlName="bookingFeeValue" />
                    </div>
                  </div>
                </div>
                <div class="row margin-top-8" *ngIf="RentalConfigForm.value.addBookingFee">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !RentalConfigForm.value.bookingFeeInternalProductID}">
                    {{ "bikeshop.rentals.configuration.add_booking_fee_linked_sku" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <p-autoComplete [(ngModel)]="newSku" field="SKU" [suggestions]="searchResult"
                                    [ngModelOptions]="{standalone: true}"
                                    placeholder="{{
                        'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                          | translate
                      }}" (completeMethod)="searchProducts($event)"
                                    (onSelect)="linkSku(newSku)">
                      <ng-template let-product pTemplate="item">
                        <div>
                          <span>{{ product.SKU }} - {{ product.Name }}</span>
                        </div>
                      </ng-template>
                    </p-autoComplete>
                    <div style="display: none"><input type="number" pInputText
                                                      formControlName="bookingFeeInternalProductID"/>
                    </div>
                  </div>
                  <div class="col-md-7 label">
                    <small>{{ 'bikeshop.rentals.configuration.add_booking_fee_linked_sku_desc' | translate }}</small>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="RentalConfigForm.value.bookingFeeInternalProductID">
                  <div class="col-md-3"></div>
                  <div class="col-md-8 linked-sku-message">
                    <div>{{configuaration.bookingFeeSKU}} - {{configuaration.bookingFeeName}}</div>
                  </div>
                  <div class="col-md-1 flex"><span class="fa fa-trash" (click)="removeSKU()"></span>
                  </div>
                </div>
              </div>


              <!--<div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': RentalConfigForm.controls['calendarDayViewInterval'].invalid}">
                  {{ "bikeshop.rentals.configuration.calendar_day_view_interval" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-clock-o"></i></span>
                    <input type="number" pInputText formControlName="calendarDayViewInterval" />
                    <div class="label">{{ 'general.minutes' | translate }}</div>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': RentalConfigForm.controls['calendarWeekViewInterval'].invalid}">
                  {{ "bikeshop.rentals.configuration.calendar_week_view_interval" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-clock-o"></i></span>
                    <input type="number" pInputText formControlName="calendarWeekViewInterval" />
                    <div class="label">{{ 'general.minutes' | translate }}</div>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': RentalConfigForm.controls['calendarMonthViewInterval'].invalid}">
                  {{ "bikeshop.rentals.configuration.calendar_month_view_interval" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-clock-o"></i></span>
                    <input type="number" pInputText formControlName="calendarMonthViewInterval" />
                    <div class="label">{{ 'general.minutes' | translate }}</div>
                  </div>
                </div>
              </div> -->


              <!-- <div class="row margin-top-8">
                <div class="col-md-4 label">
                  {{ "bikeshop.rentals.configuration.waiver_required" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="waiverRequired"></p-inputSwitch>
                  </div>
                </div>
              </div> -->

              <div class="row margin-top-16">
                <div class="col-md-12 section-header">
                  {{ 'general.notifications' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_profile.send_notification_on_rental" | translate }}:
                </div>
                <div class="col-md-9">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="sendNotificationOnRental"></p-inputSwitch>
                    <small style="
                        margin-left: 8px;
                        margin-top: auto;
                        margin-bottom: auto;
                      ">
                      {{
                      "bikeshop.shop_profile.send_notification_on_rental_info" | translate : {email: partner.eMail}
                      }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8" *ngIf="RentalConfigForm.value.sendNotificationOnRental">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_profile.rental_notification_recipients" | translate }}:
                </div>
                <div class="col-md-3">
                  <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="rentalNotificationsAddresses"/>
                  </div>
                </div>
                <div class="col-md-6" style="padding-left:0px;">
                  <div class="p-inputgroup">
                    <small style="
                    margin-top: auto;
                    margin-bottom: auto;
                  ">
                      {{
                      "bikeshop.shop_profile.rental_notification_recipients_info" | translate
                      }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.booking.waiver_text' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.waiver_terms" | translate }}:
                </div>
                <div class="col-md-9">
                  <div>
                    <quill-editor formControlName="waiverTerms"
                                  [style]="{'height':'280px', 'width':'100%'}"
                                  [modules]="modules" format="html">
                    </quill-editor>
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.configuration.cancellation_policy' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.cancellation_policy" | translate }}:
                </div>
                <div class="col-md-9">
                  <div>
                    <quill-editor formControlName="cancellationPolicy"
                                  [style]="{'height':'280px', 'width':'100%'}"
                                  [modules]="modules" format="html">
                    </quill-editor>
                  </div>
                </div>
              </div>
              
              <div class="row margin-top-16">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.configuration.print_settings' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.barcode" | translate }}:
                </div>
                <div class="col-md-1">
                  <p-inputSwitch formControlName="showBarCodeOnPrint"></p-inputSwitch>
                </div>
                <div class="col-md-8 label">
                  <small>{{ 'bikeshop.rentals.configuration.barcode_info' | translate }}</small>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.qrcode" | translate }}:
                </div>
                <div class="col-md-1">
                  <p-inputSwitch formControlName="showQRCodeOnPrint"></p-inputSwitch>
                </div>
                <div class="col-md-8 label">
                  <small>{{ 'bikeshop.rentals.configuration.qrcode_info' | translate }}</small>
                </div>
              </div>



              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button type="submit" class="iso-round-button full-width" label=""
                          [disabled]="!RentalConfigForm.valid || busy || (!RentalConfigForm.value.allowFixedRentalOptions && !RentalConfigForm.value.allowFlexibleRentalOptions)">{{
                    'bikeshop.rentals.configuration.update_configuration' | translate
                    }}</button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="bottom-right"></p-toast>
